export default __webpack_public_path__ + "static/media/fireFN13.6e9e4f56.svg";